import { z } from "@/zod";

export const TIME_FORMAT_SHORT = "00:00";
export const TIME_FORMAT_FULL = "00:00:00";

export const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/;

export const time = z
  .string()
  .refine((value) => value === "" || timeRegex.test(value), {
    message: "Invalid time",
  });

export const timeWithOptionalSeconds = time.transform((value) => {
  // got 00:00 format as input
  if (value.length === TIME_FORMAT_SHORT.length) {
    return `${value}:00`; // 00:00:00 as output
  }
  return value;
});
